export const portfolioData = [
  {
    id: 1,
    blurb:
      '<p>I built this app using Flutter/Dart for mobile deployment. It is an app that allows local residents to track current ferry/lineup conditions for the Bell Island/Portugal Cove-St.Philips Ferry Crossing.</p>',
    portURL: 'https://github.com/adamryan1983/issherunnin_flutter',
    portTitle: "Is She Runnin'? (Mobile)",
    tags: ['#Flutter', '#Dart', '#Firebase'],
    image: '/images/issherunnin-mobile.png',
  },

  {
    id: 2,
    blurb:
      '<p>I built this mobile app using Flutter/Dart for the mobile front end and Firebase for the backend. It incorporates Google Maps API as well. This app is designed to allow motorists/travellers on the Trans Canada Highway(specifically in NL) to track moose sightings and alert other drivers about potential moose presence on the highway.</p>',
    portURL: 'https://github.com/adamryan1983/mooose',
    portTitle: 'Mooose',
    tags: ['#Flutter', '#Dart', '#Firebase'],
    image: '/images/mooose.png',
  },
  {
    id: 3,
    blurb:
      '<p>I built this app using NextJS/React as a front end and Firebase as the backend. This is the web version of the Ferry App I created. The site features login/authentication using account creation, login in with Google option, and a log in with Facebook option.</p>',
    portURL: 'https://issherunnin.ca',
    portTitle: "Is She Runnin'? (Web)",
    tags: ['#React', '#NextJS', '#Typescript', '#Firebase'],
    image: '/images/issherunnin-web.png',
  },
  {
    id: 4,
    blurb:
      "<p>I built this app during my first year of Programming studies at college</p><p>This is still a work in progress and still somewhat 'unfinished'. A complete game can be finished but there is no AI incorporated beyond random choices for the computer. It was created using javascript, html5, and CSS.</p>",
    portURL: 'https://github.com/adamryan1983/Go-Fish-Game',
    portTitle: 'Go Fish game',
    tags: ['#javascript', '#html/css'],
    image: '/images/go-fish.jpg',
  },

  {
    id: 5,
    blurb:
      '<p>I built this website from scratch for my side business, Adam Ryan Photography</p><p>It was built with the intentions of drafting a new website, as well as grasp the usage of CSS frameworks. It was created using Tailwind (CSS framework), javascript, html5, and CSS.</p>',
    portURL: 'https://adamryanphotography.ca',
    portTitle: 'Adam Ryan Photography website',
    tags: ['#javascript', '#html/css', 'tailwind css'],
    image: '/images/arp-page.jpg',
  },
  {
    id: 6,
    blurb:
      '<p>I built this app using a tutorial offered by <strong>thejavascriptmastery</strong></p><p>It involves the display of information relating to covid 19 cases both globally and by country. It was created using React, MaterialUI, html5, and CSS.</ p>',
    portURL: 'https://github.com/adamryan1983/covid-19-tracker',
    portTitle: 'Covid-19 Tracker App',
    tags: ['#react', '#javascript', '#html', '#materialUI'],
    image: '/images/project-covid.jpg',
  },
];
